import Vue from "vue";
import Vuex from "vuex";

import AccountUserStore from "@Account/Scripts/Stores/AccountUserStore";

import CatalogueListStore from "@Scripts/Stores/CatalogueListStore";
import CatalogueSearchStore from "@Scripts/Stores/CatalogueSearchStore";
import CookieToastStore from "@Scripts/Stores/CookieToastStore";
import GlobalComparatorStore from "@Scripts/Stores/GlobalComparatorStore";
import GeoStore from "@Scripts/Stores/GeoStore";
import GoogleMapsStore from "@Scripts/Stores/GoogleMapsStore";
import LanguageSelectorStore from "@Scripts/Stores/LanguageSelectorStore";
import PushNotificationStore from "@Scripts/Stores/PushNotificationStore";
import NewsletterStore from "@Scripts/Stores/NewsletterStore";
import TechInfoStore from "@Scripts/Stores/TechInfoStore";
import BremboToastStore from "@Scripts/Stores/BremboToastStore";
import MyNotificationStore from "@Scripts/Stores/MyNotificationStore";
import MyTrainingStore from "@Scripts/Stores/MyTrainingStore";
import MyProductStore from "@Scripts/Stores/MyProductStore";
import MyFileSharingStore from "@Scripts/Stores/MyFileSharingStore";

Vue.use(Vuex);

export const store = new Vuex.Store({});

store.registerModule("accountUserStore", AccountUserStore);

store.registerModule("catalogueListStore", CatalogueListStore);
store.registerModule("catalogueSearchStore", CatalogueSearchStore);
store.registerModule("cookieToastStore", CookieToastStore);
store.registerModule("globalComparatorStore", GlobalComparatorStore);
store.registerModule("geoStore", GeoStore);
store.registerModule("googleMapsStore", GoogleMapsStore);
store.registerModule("languageSelectorStore", LanguageSelectorStore);
store.registerModule("pushNotificationStore", PushNotificationStore);
store.registerModule("newsletterStore", NewsletterStore);
store.registerModule("techInfoStore", TechInfoStore);
store.registerModule("bremboToastStore", BremboToastStore);
store.registerModule("myNotificationStore", MyNotificationStore);
store.registerModule("myTrainingStore", MyTrainingStore);
store.registerModule("myProductStore", MyProductStore);
store.registerModule("myFileSharingStore", MyFileSharingStore);